/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import _ from 'lodash';

// custom component import
import { v4 as uuidv4 } from 'uuid';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import SelectBoxRender from './gridComponents/SelectBoxRender';

import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
// custom function import
import {
  closeTab,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

import { tableGridHight330 } from '../../../../SharedModules/CommonConstants/commonConstants';
import reminderRecipeTableHead from './gridComponents/tableHead';
import {
  postSaveOrUpdate,
  setReminderRecipeScreenTab,
  getReminderRecipientGridList,
  getReminderUserData,
  dispatchFetchReminderRecipeList,
  handleErrorMessagesReminderRecipe,
  dispatchSaveOrUpdate,
} from '../store/Actions';
import {
  tabHighLigther,
  checkActionAccessByRole,
} from '../../../../SharedModules/utilities/utilities';
function ReminderRecipientsComponent() {
  const dispatch = useDispatch();
  const history = useHistory();
  // dispatch function
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const errorMessagesFromRedux = useSelector(
    (state) =>
      state?.sharedState?.ReminderRecipientReducer?.errorMessagesInRedux
  );
  const ReminderRecipeObj = useSelector(
    (state) => state?.sharedState?.ReminderRecipientReducer?.reminderRecipeObj
  );
  const reminderRecipeGridList = useSelector(
    (state) =>
      state?.sharedState?.ReminderRecipientReducer?.reminderRecipientList
  );
  const saveOrUpdateMessage = useSelector((state) => {
    return state.sharedState.ReminderRecipientReducer.saveOrUpdateMessage;
  });
  const ReminderUserList = useSelector(
    (state) => state?.sharedState?.ReminderRecipientReducer?.userList
  );
  // variable deceleration
  const gridRef = React.useRef();
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [successMessages, setSuccessMessage] = React.useState([]);
  const [gridParams, setGridParams] = React.useState(null);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] =
    React.useState(false);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(false);
  const [keyValue, setKeyValue] = React.useState([]);
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    !checkActionAccessByRole(process.env.REACT_APP_REPORT_ROLE, kcRoles)
  );

  React.useEffect(() => {
    if (kcRoles?.userPrivileges?.length > 0) {
      setIsEnablebyRole(
        !checkActionAccessByRole(process.env.REACT_APP_REPORT_ROLE, kcRoles)
      );
    }
  }, [kcRoles]);
  // on scroll default top level
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  
  // set Initial state values
  React.useEffect(() => {
    if (Object.keys(ReminderRecipeObj)?.length === 0) {
      setDisabledSaveCancelBtn(true);
      dispatch(getReminderRecipientGridList(''));
      dispatch(getReminderUserData());
    } else {
      const tempObj = ReminderRecipeObj;
      setDisabledSaveCancelBtn(tempObj.disabledSaveCancelBtn);
      if (tempObj?.fullScreenView) setFullScreenView(tempObj.fullScreenView);
      if (tempObj?.successMessages) setSuccessMessage(tempObj.successMessages);
    }
  }, [ReminderRecipeObj]);
  // handing by default 1st row selection function
  const onGridReady = (params) => {
    setGridParams(params);
  };
  // handing  full screen view function
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(
      setReminderRecipeScreenTab({
        ...ReminderRecipeObj,
        disabledSaveCancelBtn: disabledSaveCancelBtn,
        fullScreenView: !fullScreenView,
      })
    );
  };
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux?.length > 0) {
      tabHighLigther('/reminderRecipients', true);
    } else {
      tabHighLigther('/reminderRecipients', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // handle after call service show success and error message
  // handing refresh functionality
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (ReminderRecipeObj && Object.keys(ReminderRecipeObj).length > 0) {
      const newObj = updateTabs?.map((item) => {
        if (
          item.navTo === '/reminderRecipients' &&
          !disabledSaveCancelBtn &&
          !isEnablebyRole
        ) {
          item.isFormDirty = true;
        } else if (item.navTo === '/reminderRecipients')
          item.isFormDirty = false;
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [!disabledSaveCancelBtn|| ReminderRecipeObj, isEnablebyRole]);
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      dispatch(getReminderRecipientGridList(''));
      setDisabledSaveCancelBtn(true);
      dispatch(
        setReminderRecipeScreenTab({
          disabledSaveCancelBtn: true,
          successMessages: [constantMessageData.SUCCESSMESSAGE_GENERIC],
        })
      );
      if (!clickOncloseTabBtn) {
        dispatch(setReminderRecipeScreenTab({}));
        closeTab('/reminderRecipients', history, dispatch);
      }
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      const newObj1 = updateTabs?.map((item) => {
        if (item.navTo === '/reminderRecipients') {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
    } else if (saveOrUpdateMessage === 'failed') {
      const localErr = ReminderRecipeObj?.errorMessages || [];
      localErr.push({
        field: 'APIFailed',
        errorType: 'APIFailed',
        message: constantMessageData.FAILED_MESSAGE_GENERIC,
      });
      dispatch(
        setReminderRecipeScreenTab({
          ...ReminderRecipeObj,
          disabledSaveCancelBtn: false,
        })
      );
      dispatch(handleErrorMessagesReminderRecipe([...new Set(localErr)]));

      handleScrollToEvent();
      setSuccessMessage([]);
      setDisabledSaveCancelBtn(false);
    }
  }, [saveOrUpdateMessage]);
  const validateRequest = () => {
    let localErr = [];
    const newObj = [
      ...reminderRecipeGridList?.sort((a, b) => {
        if (a.reminderShortDescr < b.reminderShortDescr) {
          return -1;
        }
        if (a.reminderShortDescr > b.reminderShortDescr) {
          return 1;
        }
        return 0;
      }),
    ];
    for (let i = 0; i < newObj?.length; i += 1) {
      if (
        newObj[i]?.isUpdate &&
        newObj[i]?.respUserId &&
        newObj?.filter((x) => {
          return (
            x.reminderSeqNum === newObj[i]?.reminderSeqNum &&
            x.respUserId === newObj[i]?.respUserId &&
            x.id !== newObj[i].id
          );
        }).length > 0
      ) {
        localErr.push({
          field: `duplicateUserId${i}`,
          errorType: `duplicateUserId${i}`,
          message: `${constantMessageData.DUPLICATE_REMINDER_ERROR_MSG} # ${
            i + 1
          }.`,
        });
        newObj[i].duplicateUserIdErr = true;
      } else {
        localErr = localErr.filter(
          (item) => item.field !== `duplicateUserId${i}`
        );
        newObj[i].duplicateUserIdErr = false;
      }
    }
    dispatch(dispatchFetchReminderRecipeList(newObj));
    if (
      newObj?.filter((x) => {
        return x.duplicateUserIdErr;
      }).length > 0
    ) {
      dispatch(handleErrorMessagesReminderRecipe([...new Set(localErr)]));
      return false;
    }

    return true;
  };
  // save popup
  const openSave = (value) => {
    if (!value) {
      masterDataSave();
    } else {
      setOpen(value);
      setOpenCancel(false);
    }
  };
  // cancel popup
  const handelCancelClose = () => {
    setOpenCancel(false);
  };
  // handing save API calling
  const masterDataSave = () => {
    handelCancelClose();
    setOpen(false);
    const saveRequest = reminderRecipeGridList
      ?.filter((x) => {
        return x.isUpdate;
      })
      ?.map((item) => {
        return {
          reminderSeqNum: item.isDuplicateRow ? null : item.reminderSeqNum,
          reminderTypeCd: item.reminderTypeCd,
          reminderName: item.reminderName,
          rebateProgramCd: item.rebateProgramCd,
          templateId: item.templateId,
          paymentStatusTypeCd: item.paymentStatusTypeCd,
          paidPct: item.paidPct,
          owedAmt: item.owedAmt,
          daysSinceInvDistributed: item.daysSinceInvDistributed,
          usePriorQtrUraIfZeroInd: item.usePriorQtrUraIfZeroInd,
          daysSinceInvPrinted: item.daysSinceInvPrinted,
          checkPayeeCd: item.checkPayeeCd,
          respUserId: item.respUserId,
          lastUpdateDt: item.lastUpdateDt,
          lastUpdateUserId: item.lastUpdateUserId,
          corrLinkId: item.corrLinkId,
          addedDt: item.addedDt,
          addedUserId: item.addedUserId,
          rpcShortDescr: item.rpcShortDescr,
          cvShortDescr: item.cvShortDescr,
          reminderShortDescr: item.reminderShortDescr,
        };
      });
    const tempObj = {
      delReminderVO: [],
      addReminderVO: saveRequest,
    };
    dispatch(postSaveOrUpdate(tempObj));
    handleScrollToEvent();
  };
  // call after check all validation
  const onSubmit = (value) => {
    setClickOncloseTabBtn(value);
    if (validateRequest()) {
      setSuccessMessage([]);
      openSave(value);
    } else {
      handleScrollToEvent();
    }
  };
  // handle close and confirm popup
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      dispatch(dispatchSaveOrUpdate(''));
    }
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs?.filter((x) => {
        return x.navTo === '/reminderRecipients' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/reminderRecipients' && item.isFormSave) {
          item.isFormSave = false;
          onSubmit(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  // click on view history icon after call
  const handleViewHistory = (gridApi) => {
    const reminderSeqNum = gridApi.getSelectedRows()?.[0]?.reminderSeqNum;
    if (reminderSeqNum) {
      setShowViewHistory(true);
      setKeyValue({ REMINDER_SEQ_NUM: reminderSeqNum || null });
    } else {
      const localErr = errorMessagesFromRedux;
      localErr.push({
        field: 'noRowSelected',
        errorType: 'noRowSelected',
        message: constantMessageData.CONTRACT_NOT_SELECTED_ROW,
      });
      dispatch(handleErrorMessagesReminderRecipe([...new Set(localErr)]));
      /* istanbul ignore next */
      // setTimeout(() => {
      //   let localErr1 = errorMessagesFromRedux;
      //   localErr1 = localErr1.filter((item) => item.field !== 'noRowSelected');
      //   dispatch(handleErrorMessagesReminderRecipe([...new Set(localErr1)]));
      // }, 3000);
    }
  };
  // save popup
  const handleOpenClose = () => {
    setOpenCancel(true);
  };
  // click on cancel after call
  const handleSaveClose = () => {
    setOpen(false);
  };
  // handing reset All fields & data
  const resetAllFields = () => {
    handelCancelClose();
    setDisabledSaveCancelBtn(true);
    dispatch(getReminderRecipientGridList(''));
    dispatch(getReminderUserData());
    dispatch(handleErrorMessagesReminderRecipe([]));

    handleScrollToEvent();
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj1 = updateTabs?.map((item) => {
      if (item.navTo === '/reminderRecipients') {
        item.isFormSave = false;
        item.isFormDirty = false;
        item.isFormError = false;
      }
      return item;
    });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
  };
  const handleAddDuplicateRow = async (
    reminderRecipeGridRow,
    cellInfo,
    ReminderRecipeTab
  ) => {
    const tempObj = { ...cellInfo.data };
    const newObj = [...reminderRecipeGridRow];
    let rowIndex = 0;
    if (newObj && newObj.length > 0) {
      rowIndex = newObj
        ?.sort((a, b) => {
          if (a.reminderShortDescr < b.reminderShortDescr) {
            return -1;
          }
          if (a.reminderShortDescr > b.reminderShortDescr) {
            return 1;
          }
          return 0;
        })
        .findIndex((x) => {
          return x.id === cellInfo.data.id;
        });
    }
    const addNewRow = [];
    tempObj.id = uuidv4();
    tempObj.isUpdate = true;
    tempObj.isDuplicateRow = true;
    tempObj.respUserId = null;
    tempObj.respUserName = null;
    newObj.forEach((item) => {
      addNewRow.push(item);
      if (item.id === cellInfo.data?.id) {
        addNewRow.push(tempObj);
      }
    });
    await dispatch(dispatchFetchReminderRecipeList(addNewRow));
    await dispatch(
      setReminderRecipeScreenTab({
        ...ReminderRecipeTab,
        disabledSaveCancelBtn: false,
        successMessages: [],
      })
    );
    if (cellInfo?.api) {
      //setTimeout(() => {
        cellInfo.api.refreshCells({ force: true });
        cellInfo.api.forEachNode(
          (node) => node.rowIndex === rowIndex + 1 && node?.setSelected(true)
        );
        cellInfo.api.ensureIndexVisible(rowIndex + 1, null);
      //}, 1000);
    }
  };

  const onSelectionChanged = (event) => {
    const reminderSeqNum = event.api.getSelectedRows()?.[0]?.reminderSeqNum;
    if (reminderSeqNum) {
      let localErr1 = errorMessagesFromRedux;
      const alreadyExists = localErr1.some(
        (item) => item.field === 'noRowSelected'
      );
      if(alreadyExists){
        localErr1 = localErr1.filter((item) => item.field !== 'noRowSelected');
        dispatch(handleErrorMessagesReminderRecipe([...new Set(localErr1)]));
      }  
    }
  }

  return (
    <div data-testid="reminder_recipient">
      <div className="tabs-container">
        <div className="tBillPanel custom-check">
          <div className="paneldevider-line">
            <SaveCancelPopup
              open={open}
              data-testid="savePopup"
              title="Save"
              onConfim={() => {
                masterDataSave();
              }}
              onCancel={() => {
                handleSaveClose();
              }}
            />
            <SaveCancelPopup
              open={openCancel}
              data-testid="cancelPopup"
              title="Cancel"
              onConfim={() => {
                resetAllFields();
              }}
              onCancel={() => {
                handelCancelClose();
              }}
            />

            <Spinner load={spinnerLoader} />
            <div className="panel">
              {!fullScreenView && (
                <>
                  <CustomSeparator
                    parent1="System"
                    parent2="Reminder Recipient "
                  />
                  <DisplayErrorMessages
                    errorMessages={[
                      ...new Set(
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) => l.message)
                          : []
                      ),
                    ]}
                  />
                  {errorMessagesFromRedux &&
                    errorMessagesFromRedux.length === 0 && (
                      <DisplaySuccessMessages
                        successMessages={successMessages}
                      />
                    )}
                  <div className="flex-block justify-end pb-1">
                    <div className="btn-wrapper float-right">
                      <Button
                        className="btn btn-success btn-save"
                        data-testid="saveBtn"
                        disabled={disabledSaveCancelBtn}
                        onClick={() => {
                          onSubmit(true);
                        }}
                      >
                        {' '}
                        <SVGComponent iconName="Icon-awesome-save" />
                        Save
                      </Button>

                      <Button
                        className="btn btn-cancel"
                        data-testid="cancelBtn"
                        onClick={() => handleOpenClose()}
                        disabled={disabledSaveCancelBtn || isEnablebyRole}
                      >
                        <SVGComponent iconName="Icon-cancel" />
                        Cancel
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div
              id="testGrid"
              className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk"
            >
              <TableGrid
                ref={gridRef}
                gridHeight={fullScreenView ? '70vh' : tableGridHight330}
                rowData={reminderRecipeGridList?.map((item) => {
                  const firstDropdownVal = ReminderUserList?.filter((x) => {
                    return x.userId === item.respUserId;
                  });
                  if (firstDropdownVal && firstDropdownVal.length > 0) {
                    item.respUserName = `${firstDropdownVal[0].userId} | ${firstDropdownVal[0].firstName}  ${firstDropdownVal[0].lastName}`;
                  } else {
                    item.respUserName = null;
                  }
                  return item;
                })}
                columnDefs={reminderRecipeTableHead}
                fullScreenView={fullScreenView}
                gridCall={onGridReady}
                handleFullScreenViewClick={handleFullScreenView}
                handleViewHistory={handleViewHistory}
                exportFile
                helpMessage=""
                data-testid="reminder-Recipients-grid"
                fileName="Reminder Recipients"
                hideColumnsInPdf={['action']}
                singleClickEdit
                suppressCellFocus
                navigateToNextCell={navigateToNextCell}
                // tabToNextCell={tabToNextCell}
                enterMovesDown
                onCellFocused={onCellFocused}
                onSelectionChanged={onSelectionChanged}
                frameworkComponents={{
                  ActionCellRender: (cellInfo) => {
                    const ReminderRecipeTab = useSelector(
                      (state) =>
                        state?.sharedState?.ReminderRecipientReducer
                          ?.reminderRecipeObj
                    );
                    const reminderRecipeGridRow = useSelector(
                      (state) =>
                        state?.sharedState?.ReminderRecipientReducer
                          ?.reminderRecipientList
                    );
                    return (
                      <div
                        className="tdCell icon-btn-group"
                        data-testid="action-column"
                      >
                        <Dropdown className="icon-dropdown-container">
                          <Dropdown.Toggle
                            className="icon-dropdown export_wrap"
                            aria-label="export"
                          >
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="action-tooltip">Actions</Tooltip>
                              }
                            >
                              <SVGComponent iconName="Icon-export1" />
                            </OverlayTrigger>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="export_dropdown">
                            <Dropdown.Item
                              role="button"
                              data-testid="viewInvoice"
                              disabled={isEnablebyRole}
                              onClick={() => {
                                if (isEnablebyRole) {
                                  return;
                                }
                                handleAddDuplicateRow(
                                  reminderRecipeGridRow,
                                  cellInfo,
                                  ReminderRecipeTab
                                );
                              }}
                            >
                              Duplicate
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    );
                  },
                  rpcCellRenderer: (cellInfo) => {
                    const name = cellInfo?.data?.reminderShortDescr;
                    if (name && name.length > 11) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                  DescriptionCellRender: (cellInfo) => {
                    const name = cellInfo?.data?.reminderName;
                    if (name && name.length > 20) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                  RespUserIdCellRender: (cellInfo) => {
                    return <SelectBoxRender {...cellInfo} />;
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="REMINDER"
          keyValue={keyValue}
        />
      )}
    </div>
  );
}
export default ReminderRecipientsComponent;
